import { apiClient } from './client';

const ADMIN_BASE_URL = '/admin';

export const adminService = {
  // User Management
  users: {
    // List all users with pagination
    async list(params = {}) {
      console.log('=== AdminService - Users List ===');
      console.log('Params:', params);
      console.log('Auth check:', {
        isAuthenticated: localStorage.getItem('access_token'),
        userData: localStorage.getItem('user_data')
      });
      
      const { page = 1, limit = 20 } = params;
      try {
        const response = await apiClient.get(`${ADMIN_BASE_URL}/users?page=${page}&limit=${limit}`);
        console.log('Users list response:', response);
        return response;
      } catch (error) {
        console.error('Users list error:', error);
        throw error;
      }
    },

    // Create new user
    async create(userData) {
      return apiClient.post(`${ADMIN_BASE_URL}/users`, userData);
    },

    // Get user by ID
    async getById(userId) {
      return apiClient.get(`${ADMIN_BASE_URL}/users/${userId}`);
    },

    // Update user
    async update(userId, userData) {
      return apiClient.put(`${ADMIN_BASE_URL}/users/${userId}`, userData);
    },

    // Delete user
    async delete(userId) {
      return apiClient.delete(`${ADMIN_BASE_URL}/users/${userId}`);
    },

    // Get user's tenants
    async getUserTenants(userId) {
      return apiClient.get(`${ADMIN_BASE_URL}/users/${userId}/tenants`);
    },

    // Assign user to tenant
    async assignTenant(userId, tenantData) {
      return apiClient.post(`${ADMIN_BASE_URL}/users/${userId}/assign-tenant`, tenantData);
    },

    // Remove user from tenant
    async unassignTenant(userId, tenantId) {
      return apiClient.delete(`${ADMIN_BASE_URL}/users/${userId}/unassign-tenant/${tenantId}`);
    }
  },

  // Tenant Management
  tenants: {
    // List all tenants
    async list(params = {}) {
      console.log('=== AdminService - Tenants List ===');
      console.log('Params:', params);
      
      const { page = 1, limit = 20 } = params;
      try {
        const response = await apiClient.get(`${ADMIN_BASE_URL}/tenants?page=${page}&limit=${limit}`);
        console.log('Tenants list response:', response);
        return response;
      } catch (error) {
        console.error('Tenants list error:', error);
        throw error;
      }
    },

    // Create new tenant
    async create(tenantData) {
      return apiClient.post(`${ADMIN_BASE_URL}/tenants`, tenantData);
    },

    // Get tenant by ID
    async getById(tenantId) {
      return apiClient.get(`${ADMIN_BASE_URL}/tenants/${tenantId}`);
    },

    // Update tenant
    async update(tenantId, tenantData) {
      return apiClient.put(`${ADMIN_BASE_URL}/tenants/${tenantId}`, tenantData);
    },

    // Delete tenant
    async delete(tenantId) {
      return apiClient.delete(`${ADMIN_BASE_URL}/tenants/${tenantId}`);
    },

    // Get tenant's users
    async getTenantUsers(tenantId) {
      return apiClient.get(`${ADMIN_BASE_URL}/tenants/${tenantId}/users`);
    },

    // Get tenant audit trail
    async getAuditTrail(tenantId, params = {}) {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") {
          searchParams.append(k, v);
        }
      });
      const qs = searchParams.toString();
      return apiClient.get(`${ADMIN_BASE_URL}/tenants/${tenantId}/audit-trail${qs ? `?${qs}` : ""}`);
    }
  },

  // System Configuration
  configs: {
    // Get system configurations
    async list() {
      return apiClient.get(`${ADMIN_BASE_URL}/configs`);
    },

    // Get public system configurations
    async getPublic() {
      return apiClient.get('/configs/public');
    },

    // Update system configuration
    async update(configData) {
      return apiClient.put(`${ADMIN_BASE_URL}/configs`, configData);
    }
  },

  // Dashboard Analytics (if needed)
  dashboard: {
    // Get admin dashboard stats
    async getStats() {
      return apiClient.get(`${ADMIN_BASE_URL}/dashboard/stats`);
    }
  }
};

// Helper functions for admin operations
export const adminHelpers = {
  // Check if user can access admin features
  canAccessAdmin() {
    try {
      const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
      return userData.is_admin === true;
    } catch {
      return false;
    }
  },

  // Validate admin access and throw error if not admin
  requireAdminAccess() {
    if (!this.canAccessAdmin()) {
      throw new Error('Access denied: Admin privileges required');
    }
  },

  // Format admin error responses
  handleAdminError(error) {
    if (error.response?.status === 403) {
      return 'Access denied: Super admin privileges required';
    }
    if (error.response?.status === 401) {
      return 'Authentication required';
    }
    if (error.response?.data?.message) {
      return error.response.data.message;
    }
    return 'An error occurred. Please try again.';
  }
};

export default adminService;